import templateDefaults from '../templateDefaults';

export default {
  previewImage: '/img/modern/l3-one-line.png',
  title: '1-line Lower Third',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Modern Lower Third 1 Line',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'image',
          name: 'Logo',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: 'https://via.placeholder.com/236x120.png?text=LOGO',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 750,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 904,
            left: 1581,
            width: 236,
            height: 120,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Headline Text',
          locked: false,
          text: '<p><strong>This is One line of text</strong></p>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 750,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 916,
            left: 119,
            width: 1418,
            height: 50,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 48,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Sub text',
          locked: false,
          text: '<p>This is a line of subtext</p>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 750,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 984,
            left: 118,
            width: 1418,
            height: 30,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Heading BG',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: 'rgb(0, 33, 76)',
          backgroundSize: 'cover',
          gradientDirection: 0,
          gradientColorOne: 'rgb(221, 221, 221)',
          gradientColorTwo: 'rgb(255, 255, 255)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 904,
            left: 95,
            width: 1470,
            height: 73,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Sub text BG',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 33, 76)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 978,
            left: 95,
            width: 1470,
            height: 45,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: false,
          name: 'Live',
          locked: false,
          text: '<p><strong>LIVE</strong></p>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeInUp',
          animationInDuration: 1000,
          animationInDelay: 1500,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 857,
            left: 127,
            width: 86,
            height: 42,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeInUp',
          animationInDuration: 1000,
          animationInDelay: 1500,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(212, 1, 1)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 856,
            left: 95,
            width: 150,
            height: 50,
            opacity: 1,
          },
        },
      ],
    };
  },
};
